import React, {useEffect, useState} from 'react';
import { Route, Routes } from 'react-router-dom';
import ReactGA from 'react-ga';

import HomePage from './Components/HomePage';
import ProjectDetails from "./Components/ProjectDetails";
import ProjectsPresentation from "./Components/ProjectsPresentation";
import projectData from "./data/projects";
import Menu from "./Components/Menu";
import Cursor from "./Components/Cursor";

function App() {
    const [projects, setProjects] = useState([]);
    useEffect(() => {
        // Initialisez Google Analytics
        ReactGA.initialize('GTM-5HPT6MRQ');
        // Envoyez une page vue à chaque changement de page
        ReactGA.pageview(window.location.pathname + window.location.search);

        // Chargez vos données de projet ici
        setProjects(projectData);
    }, []);

    return (
<>
        <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/projects" element={<ProjectsPresentation />} />
            <Route
                path="/project/:title"
                element={<ProjectDetails projects={projects} />}
            />
        </Routes>
        <Menu/>
        <Cursor />
    </>
    );
}

export default App;
